<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useDisciplinePaymentLinks } from '../model/discipline-payment-links.hook'
import DisciplinePaymentOptions from './DisciplinePaymentOptions.vue'
import DisciplinePaymentSummary from './DisciplinePaymentSummary.vue'
import DisciplinePaymentShare from './DisciplinePaymentShare.vue'

defineOptions({
  name: 'DisciplinePaymentLinks',
})

const {
  close,
} = useDisciplinePaymentLinks()
</script>

<template>
  <CardAdmin
    title="Generate payment links"
    class="discipline-payment-links"
    fullwidth
  >
    <template #header>
      <BtnPrimary
        text="Close"
        color="emerald"
        @click="close"
      />
    </template>
    <div class="discipline-payment-links__body">
      <DisciplinePaymentOptions />
      <div class="discipline-payment-links__settings">
        <DisciplinePaymentSummary />
        <div class="discipline-payment-links__separator" />
        <DisciplinePaymentShare />
      </div>
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./DisciplinePaymentLinks.scss" />
